import classNames from "classnames";

// Exact SVG paths from Figma design (node-id=15399-9522)
const svgPaths = {
  // Outer tab shape - the semi-circular button background
  tabBody: "M30 29.74C30 35.02 27.27 39.66 23.15 42.33C23.13 42.34 23.12 42.35 23.1 42.36C20.19 44.49 15 46.41 15 59.48C15 46.41 9.81 44.49 6.9 42.36C6.88 42.36 6.87 42.34 6.85 42.33C2.73 39.66 0 35.02 0 29.74C0 24.46 2.73 19.82 6.85 17.15C6.87 17.14 6.88 17.13 6.9 17.12C9.81 14.99 15 13.07 15 0C15 13.07 20.19 14.99 23.1 17.12C23.12 17.13 23.13 17.14 23.15 17.15C27.27 19.82 30 24.46 30 29.74Z",
  // Inner circle
  innerCircle: "M15 39.7402C20.5228 39.7402 25 35.2631 25 29.7402C25 24.2174 20.5228 19.7402 15 19.7402C9.47715 24.2174 5 24.2174 5 29.7402C5 35.2631 9.47715 39.7402 15 39.7402Z",
  // Chevron pointing left (collapse)
  chevronLeft: "M16.0399 33.8399L12.6899 29.7399L16.0399 25.6499L17.3099 26.6899L14.8099 29.7399L17.3099 32.7899L16.0399 33.8399Z",
};

interface DrawerButtonProps {
  isCollapsed?: boolean;
  className?: string;
}

export default function DrawerButton({ isCollapsed = false, className }: DrawerButtonProps) {
  return (
    <div className={classNames("relative w-[30px] h-[60px] group cursor-pointer", className)} data-name="drawer_button">
      <svg
        className="block w-full h-full"
        viewBox="0 0 30 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_drawer_button)">
          {/* Outer tab shape - dark navy background */}
          <path
            d={svgPaths.tabBody}
            fill="#202936"
          />
          {/* Inner circle - matches sidebar background */}
          <path
            d="M15 39.7402C20.5228 39.7402 25 35.2631 25 29.7402C25 24.2174 20.5228 19.7402 15 19.7402C9.47715 19.7402 5 24.2174 5 29.7402C5 35.2631 9.47715 39.7402 15 39.7402Z"
            className="fill-[#293444] group-hover:fill-[#3a4a5e] transition-[fill] duration-200"
          />
          {/* Chevron arrow - rotates based on collapsed state */}
          <path
            d={svgPaths.chevronLeft}
            className={classNames(
              "fill-[#98ABC9] transition-all duration-200",
              { "origin-center": true }
            )}
            style={{
              transformOrigin: "15px 29.74px",
              transform: isCollapsed ? "rotate(180deg)" : "rotate(0deg)",
            }}
          />
        </g>
        <defs>
          <clipPath id="clip0_drawer_button">
            <rect width="30" height="60" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}
